import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { UnauthenticatedSalesModal } from '@phishtool/products';
import ExpandableContentSection from '~components/expandable-content-section';
import FAQ from '~components/faq';
import Hero from '~components/hero';
import { MSSPDemoButton } from '~components/mssp-demo-button';
import MSSPPricing from '~components/mssp-pricing';
import ThreeCardSection from '~components/three-card-section';
import { unauthenticatedUserService, contentService } from '~service';
const MSSPs = () => {
    const { data } = contentService.useGetMSSPContent({});
    if (!data) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Hero, Object.assign({}, data.hero, { children: _jsx(MSSPDemoButton, {}) })), _jsx(ThreeCardSection, Object.assign({}, data.threeCardSection)), _jsx(ExpandableContentSection, Object.assign({}, data.expandableContentSection)), _jsx(MSSPPricing, Object.assign({}, data.pricing)), _jsx(FAQ, Object.assign({}, data.faq)), _jsx(UnauthenticatedSalesModal, { source: "web-mssp", useContactSalesTeam: unauthenticatedUserService.useContactSalesTeam })] }));
};
export default MSSPs;
